import { render } from "./HotspotLabelsButton.vue?vue&type=template&id=8296ceda"
import script from "./HotspotLabelsButton.vue?vue&type=script&lang=js"
export * from "./HotspotLabelsButton.vue?vue&type=script&lang=js"

import "./HotspotLabelsButton.vue?vue&type=style&index=0&id=8296ceda&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__